<template>
		<div class="content wrap-page">
		<Header></Header>
			<div class="info crfff">
        <div class="back" @click="back" style="">
          <img width="70" src="../../static/images/back.png" />
          <span class="fs50 w-title ac">{{$t('Category')}}</span>
        </div>
        <div class="tab-content mt50">
          <!-- <div class="nav-tab">
            <span class="tab-li" @click="clickTab(key)" :class="{'btn-purple':active==key}" v-for="(item,key,index) in redeemList"><span>{{item.type_name}}</span></span>
          </div> -->
          <div class="books-content">
            <div class="books-block disflex">
              <div class="books-li" v-for="(item1,key,index) in redeemList" @click="getUpgrade(item1)">
                <div class="li-block por ac">
                  <img :src="item1.image">
                  <div class="block2-font">
                    <div class="font">{{item1.name}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
			</div>
		</div>
</template>
<script>
import Header from '../components/Header'
import Dialog from '../components/dialog'
export default {
    components:{
		Header,
    Dialog
    },
    data() {
      return {
       isShow:null,
       info:{},
       redeemInfo:{},
        redeemList:[],
        active:'general',
        upgradeInfo:{
          upgrade:{
            tip:''
          }
        }
      }
    },
	created(){
    this.getRedeem()
	},
  methods: {

    getToNav(url){
      this.$router.push({path:'/'+url});
    },
		back(){
			this.$router.go(-1);
      // this.$router.push({path:'/land',query: {msisdn:this.$route.query.mobile}});
		},
    clickTab(item){
      this.active = item
    },
    getUpgrade(item){
      console.log(item)
      let data = {
         question_type_id:item.id
       }
       this.$parent.loadModal(true);
       this.$api.post('/api/index/select_question_type',data,r =>{
         this.$utils.alertText(r.msg,80, 1000);
         this.$router.push({path:'/dailyChallenge',query: {id:item.id}});
         this.$parent.loadModal(false);
       })
    },
    cancelBookDialog(){
      this.$refs.bookDialog.closeMask();
    },
    getRedeem(){
      let that = this
      that.$parent.loadModal(true);
      that.$api.post('/api/book/select_list',null,r =>{
        that.redeemList = r.data
        that.$parent.loadModal(false);
      })
    },
	}
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/page/selectChallenge.vue